import React from 'react'
import './styles.scss'
import { config } from './config'

interface Props {
  url?: string
  covers?: string[]
  infos?: [string, React.ReactNode]
  colors?: { main: string; sub: string; cover: string }
}

export const PartialCoverdImage = ({
  url,
  covers,
  infos,
  colors = { main: '#000', sub: '#aaa', cover: '#fff' }
}: Props) => (
  <div className='PartialCoverdImage'>
    {url && <img src={require('images/' + url)} />}
    {covers &&
      covers.map((cover,i) => (
        <div
        key={i}
          className={`cover ${cover}`}
          style={{
            backgroundColor: colors.cover,
            color: colors.main
          }}
        >
          {infos && infos[0] === cover && infos[1]}
        </div>
      ))}
  </div>
)
